var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: { visible: _vm.showModal, size: "small" },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "header" }, [
        _c(
          "div",
          { staticClass: "dialog__icon--close" },
          [
            _c("CompassIconButton", {
              attrs: { icon: "close" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default acenter" },
          [
            _c("img", {
              attrs: {
                src:
                  "/ressources/logged/img/staff/illustration-popin-company-infos.svg",
                width: "220"
              }
            }),
            _vm._v(" "),
            _c("h2", { staticClass: "mt-4 typographies-heading-h2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Complétez les informations sur votre entreprise"
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "m-0 gray-60 typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Ainsi, nous vous proposons des améliorations répondant à vos besoins métier."
                      )
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "positionTeamForm",
                staticClass: "mt-5 aleft",
                attrs: {
                  labelPosition: "top",
                  model: _vm.form,
                  rules: _vm.rules
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.activity_area"),
                      prop: "business_segment",
                      error: _vm.errors.get("business_segment")
                    }
                  },
                  [
                    _c("select-input", {
                      attrs: {
                        mode: "edit",
                        options: _vm.activities,
                        placeholder: _vm.$t.__(
                          "PopupAprilTeamPosition.select_area"
                        ),
                        appendToBody: true
                      },
                      model: {
                        value: _vm.form.business_segment,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "business_segment", $$v)
                        },
                        expression: "form.business_segment"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.potential_users_number"),
                      prop: "number_of_employees",
                      error: _vm.errors.get("number_of_employees")
                    }
                  },
                  [
                    _c("select-input", {
                      attrs: {
                        mode: "edit",
                        options: _vm.nbemplyees,
                        placeholder: _vm.$t.__(
                          "PopupAprilTeamPosition.select_users_number"
                        ),
                        appendToBody: true
                      },
                      model: {
                        value: _vm.form.number_of_employees,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "number_of_employees", $$v)
                        },
                        expression: "form.number_of_employees"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "bold mb-2" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Et à propos de vous")))
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "PopupAprilTeamPosition.what_team_do_you_work_in"
                      ),
                      prop: "team",
                      error: _vm.errors.get("team")
                    }
                  },
                  [
                    _c("select-input", {
                      attrs: {
                        mode: "edit",
                        options: _vm.teams,
                        placeholder: _vm.$t.__(
                          "PopupAprilTeamPosition.select_team"
                        ),
                        appendToBody: true
                      },
                      on: { input: _vm.updateTeam },
                      model: {
                        value: _vm.form.team,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "team", $$v)
                        },
                        expression: "form.team"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("PopupAprilTeamPosition.your_job"),
                      prop: "position",
                      error: _vm.errors.get("position")
                    }
                  },
                  [
                    _c("select-input", {
                      attrs: {
                        mode: "edit",
                        options: _vm.activePositions,
                        placeholder: _vm.$t.__(
                          "PopupAprilTeamPosition.select_your_job"
                        ),
                        appendToBody: true
                      },
                      model: {
                        value: _vm.form.position,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "position", $$v)
                        },
                        expression: "form.position"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-5 aright" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("PopupAprilTeamPosition.ask_me_later"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.continue"),
                        type: "primary",
                        disabled: _vm.isDisabledContinue
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submitForm("positionTeamForm")
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }